import { useEffect } from "react";
import { StockExchangeCard } from "./card";
import { StockExchangeNew } from "./new";
import { Routes, Route } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { StockExchangesTable } from "./table";

export default function StockExchange() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Bourses");
  }, []);

  return (
    <Routes>
      <Route index element={<StockExchangesTable />} />
      <Route path="/new" element={<StockExchangeNew />} />
      <Route path=":id" element={<StockExchangeCard />} />
    </Routes>
  );
}
